export default "__VITE_ASSET__53ecf7ef__"